import React from 'react';
import I18n from 'i18n-js';
import PriceGuideGraphIcon from '../../../../images/price-guide-tool/price-guide-graphs.svg';

export default function CSPPriceGuideModuleOrdersEmptyState() {
  return (
    <div className="csp-price-guide-module-orders-empty-state">
      <img 
        src={PriceGuideGraphIcon} 
        alt={I18n.t('discovery.priceGuideTool.cspModule.nullState.imageAlt')} 
      />
      <div className="csp-price-guide-module-orders-empty-state__description">
        {I18n.t('discovery.priceGuideTool.cspModule.emptyState.description')}
      </div>
    </div>
  );
}
